import { defineFcm } from '../shared/factory';

export const FCM_COMMS_STACK_SUBJECT_LINE_EXPERIMENTATION_ENABLED = defineFcm(
	'comms_stack_subject_line_experimentation_enabled',
)
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'comms-stack',
		context: 'comms stack',
		description: 'Global flag to enable Bandit experimentation of subject lines in emails.',
	});
